import { useMemo } from "react";
import { useProductData } from "~/hooks/use-product-data";
import { getBadgeStatusFromRow, ERROR_STATUSES } from "./utils";
import { GenerationStatusBadge } from "./generation-status-badge";

interface TableStatusBadgesProps {
  row: { original: { id: string } };
  fetch?: boolean;
}

export const TableStatusBadges = ({ row, fetch }: TableStatusBadgesProps) => {
  const productId = row.original.id;

  const { product, error } = useProductData(fetch ? productId : undefined);

  const { keywordsStatus, descriptionStatus, subjectsStatus } = useMemo(
    () => (error ? ERROR_STATUSES : getBadgeStatusFromRow(product)),
    [product, error],
  );

  return (
    <div className="flex items-center justify-start gap-x-1">
      <GenerationStatusBadge labelKey="keywords" status={keywordsStatus} />
      <GenerationStatusBadge labelKey="subjects" status={subjectsStatus} />
      <GenerationStatusBadge
        labelKey="description"
        status={descriptionStatus}
      />
    </div>
  );
};
